import { Box, type SxProps, type Theme } from '@mui/material';

export const BrowserGrid = ({
  children,
  gap = '24px',
  columns = 2,
  sx,
}: {
  children: React.ReactNode;
  gap?: string;
  columns?: number;
  sx?: SxProps<Theme>;
}) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};
